<!--
  Generated template for the ResoultRanglistPage page.

  See http://ionicframework.com/docs/components/#navigation for more info on
  Ionic pages and navigation.
-->

<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" (click)="navCtrl.back()"></ion-back-button>
    </ion-buttons>
    <ion-title>
      {{ search.ename }}
    </ion-title>
  </ion-toolbar>
</ion-header>


<ion-content>
  <ion-list>

    <result-ranglist-list-item *ngFor="let item of list" [result]="item"></result-ranglist-list-item>

    <ion-infinite-scroll #infiniteScroll (ionInfinite)="loadNextPage(infiniteScroll)" *ngIf="list.length%25===0 && list.length>0">
      <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="{{'GLOBAL_SEARCH_LOADING_MORE' | translate}}">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-list>
</ion-content>